import { ViewTaskSelectionHandlingService } from "./modules/shared/Services/view-task-selection-handling.service";
import {inject} from "@angular/core";
import {SecureStorageService} from "./modules/core/services/secure-storage.service";
import {LocalStorageRelatedData} from "./local-storage-related-data.model";
import {OrgBUProjectTeamStructure} from "./models/custom-models/org-buproject-team-structure";

export function visibilityChangeListenerFactory(
    viewTaskSelectionHandlingService: ViewTaskSelectionHandlingService,
): () => void {
    const secureStorageService = inject(SecureStorageService)
    return () => {
        let timeoutId: any;
        const startTimeout = () => {
            timeoutId = setTimeout(
                () => {
                    viewTaskSelectionHandlingService.storeTaskSelectedEntityToLocal(null);
                },
                2 * 60 * 1000,
            ); // 2 minutes
        };

        const clearTimeoutFunc = () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
                timeoutId = null;
            }
        };

        const handleVisibilityChange = () => {
            if (document.hidden) {
                startTimeout();
            } else {
                clearTimeoutFunc();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        // Restore selection from localStorage when the app initializes
        const storedSelection = secureStorageService.getSessionItem<OrgBUProjectTeamStructure>(LocalStorageRelatedData.SessionStorage.VIEW_TASK_TEAM_SELECTED_ENTITY);
        if (storedSelection) {
            try {
                viewTaskSelectionHandlingService.storeTaskSelectedEntityToLocal(storedSelection);
            } catch (e) {}
        }
    };
}
